import { getBookIdNumber } from "@/shared/utils/content/content";

export const makeLoaderIdBook = (bookId) => "loader/content/book-" + getBookIdNumber(bookId);
export const makeLoaderIdBookTOC = (bookId) => "loader/content/book-toc-" + getBookIdNumber(bookId);
